import { Component, OnInit } from '@angular/core';
import { Subject, filter, noop, tap } from 'rxjs';
import { MessageService } from 'primeng/api';
import { StoreChangesService } from 'projects/shared/services/store-changes.service';
import { SideMenuService } from '../layout/side-menu/services/side-menu.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  loginMessageAfter!: string;
  endsubs$: Subject<any> = new Subject();

  topUpOrdersCount: any = 0

  constructor(
    private _messageService: MessageService,
    private _storeChangesServ: StoreChangesService,
    private _sideMenuService: SideMenuService
  ) {}

  ngOnInit(): void {
    this.loginMessage();
    this.getTopUpOrdersCount()
  }

  ngAfterViewInit(): void {
    if (this.loginMessageAfter != '') {
      this._messageService.add({ severity: 'success', summary: 'Success', detail: this.loginMessageAfter });
    }
  }

  getTopUpOrdersCount() {
    this._sideMenuService.topUpsCount_BS.pipe(
      filter( count => !!count ),
      tap(
        count => {
          this.topUpOrdersCount =  Object.values(count).reduce((sum: any, count: any) => sum + count, 0);;
        }
      )
    ).subscribe(noop)
  }

  loginMessage() {
    this._storeChangesServ.getloginMessage().subscribe(res => {
      this.loginMessageAfter = res
    });
  }

  

}
